<div mat-dialog-content class="prose" [innerHtml]="data.content"></div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="false" (click)="openDocumentation()">Documentation</button>
    <button mat-button mat-dialog-close="true" cdkFocusInitial>Close</button>
</div>
